/* eslint-disable func-names */
import Backbone from "backbone";
import Marionette from "backbone.marionette";
import Validation from "backbone-validation";
import cookie from "js-cookie";
import qs from "query-string";
import _ from "lodash";
import $ from "jquery";

import { uploadAWSFile } from "lib/vendor/aws";
import wsStorage from "lib/wsStorage";

import config from "./config";

// Automatically combine parent/child properties when extending
const views = [Marionette.View, Marionette.CompositeView];
_.each(views, (view) => {
    const _extend = view.extend;
    /* eslint-disable no-param-reassign */
    view.extend = function (protoProps, staticProps) {
        if (protoProps.ui && this.prototype.ui) {
            _.defaults(protoProps.ui, this.prototype.ui);
        }

        if (protoProps.events && this.prototype.events) {
            _.defaults(protoProps.events, this.prototype.events);
        }

        return _extend.call(this, protoProps, staticProps);
    };
    /* eslint-enable no-param-reassign */
});

const _mextend = Backbone.Model.extend;
Backbone.Model.extend = function (protoProps, staticProps) {
    if (protoProps.defaults && this.prototype.defaults) {
        _.defaults(protoProps.defaults, this.prototype.defaults);
    }

    return _mextend.call(this, protoProps, staticProps);
};

const getQueryParam = function (variable) {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i += 1) {
        const pair = vars[i].split("=");
        if (pair[0] == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
};

function updateQueryParam(params) {
    const query = qs.parse(window.location.search);
    _.extend(query, params);
    return qs.stringify(query);
}

// Scroll to an element
function scrollTo($el) {
    if (!$el.length) {
        return;
    }

    let scrollTop = 0;
    let $body = $("body");

    const $modal = $(".jquery-modal.current");
    if ($modal.is(":visible")) {
        scrollTop = $el.first()[0].offsetTop;
        $body = $modal;
    } else {
        scrollTop = $body.scrollTop() + ($el.first().offset().top - 50); // header
    }

    $body.animate({ scrollTop }, "slow");
}

/**
 * Saves the input file(resume) to the s3 bucket specific in config.js
 * @param {*} file
 */
const resumeSave = async (file) => {
    if (!file) {
        throw Error("No file specified.");
    }

    const {
        bucketRegion: s3BucketRegion,
        bucketName: s3AssetsBucket,
        identityPoolID: awsCognitoPoolId,
    } = config.aws;

    if (!(s3BucketRegion && s3AssetsBucket && awsCognitoPoolId)) {
        throw Error("resume upload settings improperly configured");
    }

    return uploadAWSFile({
        s3BucketRegion,
        s3AssetsBucket,
        awsCognitoPoolId,
        file,
        fileLink: buildLink(file),
        ACL: "private",
    });
};

// function to build a hash value for resume for s3 reference
// hash the file type, size, and last modified and store the file type
// place in folder of current timestamp
function buildLink(file) {
    let hash = 0;
    const str = file.type + file.size + file.lastModified;
    if (str.length == 0) return hash;
    for (let i = 0; i < str.length; i += 1) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    hash = Math.abs(hash);
    const fileEnd = file.type.substring(file.type.lastIndexOf("/") + 1);
    const d = new Date();

    // Build the s3 path link - YYYYMM/currentDateTime_hash.filetype
    return `${d.getFullYear() + `0${d.getMonth() + 1}`.slice(-2)}/${Date.now()}_${hash}.${fileEnd}`;
}

function bindValidation() {
    const validationTypes =
        "input[type=text], input[type=tel], input[type=email], input[type=password], select, textarea";
    _.extend(Validation.callbacks, {
        valid(view, attr) {
            const $group = view.$(`#${attr}`).closest(".form-group");
            $group.removeClass("has-error");
            $group.find(validationTypes).first().removeClass("has-error");
            $group.find(".help-block").html("").addClass("hidden");
        },
        invalid(view, attr, error) {
            const $group = view.$(`#${attr}`).closest(".form-group");

            $group.addClass("has-error");
            $group.find(validationTypes).first().addClass("has-error");
            $group.find(".help-block").html(error).removeClass("hidden");
        },
    });
}

function showToast($msg, durationMS) {
    if (!$msg) {
        const checkmark = $.staticURL("checkmark-white.svg");
        $msg = $(`<span><img src="${checkmark}" /> Changes saved</span>`);
    }

    if (typeof $msg === "string") {
        $msg = $(`<span>${$msg}</span>`);
    }

    $(".toast-message").append($msg);
    $msg.fadeIn("fast", () => {
        setTimeout(() => {
            $msg.fadeOut("fast");
        }, durationMS || 1000);
    });
}

function redirectToReferral(shouldShow, campaign, url) {
    url = url || "/";

    if (campaign) {
        const key = `ref-${campaign}`;
        const count = Number(wsStorage.getItem(key) || 0) + 1;
        wsStorage.setItem(key, count);

        if (shouldShow(count)) {
            url = `/referral/?c=${campaign}`;
        }
    }

    setTimeout(() => {
        window.location.href = url;
    }, 0);
}

// http://stackoverflow.com/questions/10073699/pad-a-number-with-leading-zeros-in-javascript
function pad(n, width, z) {
    z = z || "0";
    n = `${n}`;
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

function showLoginChat() {
    if (window.FrontChat) {
        return;
    }

    // https://stackoverflow.com/questions/12820953/asynchronous-script-loading-callback#answer-12821561
    const o = document.createElement("script");
    const s = document.getElementsByTagName("script")[0];

    o.src = "https://chat-assets.frontapp.com/v1/chat.bundle.js";
    o.addEventListener("load", () => {
        window.FrontChat("init", {
            chatId: "a575a4a463baee19faab3cb6f3d264a8",
            useDefaultLauncher: true,
        });
    });

    s.parentNode.insertBefore(o, s);
}

function shouldShowLogin() {
    if (window.authUser) {
        return false;
    }
    return getQueryParam("usr") || cookie.get("wslogin");
}

// utility func for line clamping calculations
export const actualLineHeight = (element) => {
    const lineHeight = parseFloat(getComputedStyle(element).getPropertyValue("line-height"));
    if (lineHeight > 0) {
        return lineHeight;
    }

    const clone = element.cloneNode();
    clone.innerHTML = "<br />";
    element.appendChild(clone);
    const singleHeight = clone.offsetHeight;
    clone.innerHTML = "<br /><br />";
    const doubleHeight = clone.offsetHeight;
    element.removeChild(clone);
    return doubleHeight - singleHeight;
};

export default {
    bindValidation,
    getQueryParam,
    updateQueryParam,
    scrollTo,
    redirectToReferral,
    resumeSave,
    showLoginChat,
    shouldShowLogin,
    actualLineHeight,
    showToast,
    pad,
};
